import { ERROR_SEVERITY, SEVERITY_TYPE, SUCCESS_SEVERITY } from 'src/components/CustomSnackBar/interfaces';
import { useGetLiquidationFile, useGetLiquidationSummary } from 'src/hooks/promotions';
import GenericActionButton from 'src/components/GenericActionButton';
import { PRIMARY_PAYMENT_DEFAULT } from 'src/global/theme/colors';
import modoHeader from 'src/global/assets/images/modoHeader.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import errorIcon from 'src/global/assets/icons/errorIcon.svg';
import { getUserCompanies } from 'src/redux/reducers/user';
import CustomSnackBar from 'src/components/CustomSnackBar';
import { IntlNumberFormat } from 'src/utils/currency';
import { Company } from 'src/interfaces/company';
import Spinner from 'src/components/Spinner';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Text from 'src/components/Text';

import { styles } from './styles';

const NewDebitInfo = () => {
  const [snackBarSeverity, setSnackBarSeverity] = useState<SEVERITY_TYPE>(SUCCESS_SEVERITY);
  const { classes } = styles();
  const userCompanies: Company[] = useSelector(getUserCompanies);
  const [companyId, setCompanyId] = useState(null);
  const [searchParams, _setSearchParams] = useSearchParams();
  const {
    data: liquidationSummaryInfo,
    isLoading,
    isError
  } = useGetLiquidationSummary(searchParams.get('file_id'), companyId);
  const onError = () => {
    setSnackBarSeverity(ERROR_SEVERITY);
    setShowToast(true);
  };
  const onSuccess = () => {
    setSnackBarSeverity(SUCCESS_SEVERITY);
    setShowToast(true);
  };
  const { mutate } = useGetLiquidationFile(searchParams.get('file_id'), companyId, onError, onSuccess);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (userCompanies.length >= 1) {
      const companyId = Number(searchParams.get('company_id'));
      const isValidCompanyId = userCompanies.some((item) => item.id === companyId);
      if (isValidCompanyId) {
        setCompanyId(companyId);
      }
    }
  }, [userCompanies]);

  return isLoading ? (
    <div data-testid="spinner_content">
      <Spinner />
    </div>
  ) : (
    <div className={classes.container}>
      <img className={classes.header} src={modoHeader} alt="header" />
      <div className={classes.bodyContainer}>
        <div className={classes.body}>
          {isError || !companyId ? (
            <>
              <img src={errorIcon} alt="ícono de error" />
              <Text variant="H3-Medium" className={classes.errorTitle}>
                {companyId
                  ? 'Ocurrió un error al cargar la página'
                  : 'No tenés permiso para acceder a esta archivo'}
              </Text>
              <Text variant="Callout-Regular" className={classes.errorSubtitle}>
                {companyId
                  ? 'Por favor, intentá más tarde'
                  : 'Para solicitar acceso, comunicate con finance-dd@modo.com.ar'}
              </Text>
              <GenericActionButton
                label="Ir al inicio"
                onClick={() => navigate('/')}
                className={classes.button}
              />
            </>
          ) : (
            <>
              <Text variant="Callout-Regular">Recupero:</Text>
              <Text variant="H3-Medium" color={PRIMARY_PAYMENT_DEFAULT} className={classes.text}>
                {liquidationSummaryInfo.dedi_name}
              </Text>
              <Text variant="Callout-Regular">Monto a debitarse:</Text>
              <Text variant="H3-Medium" color={PRIMARY_PAYMENT_DEFAULT} className={classes.text}>
                {IntlNumberFormat(liquidationSummaryInfo.amount_to_pay)}
              </Text>
              <Text variant="Callout-Regular">Promos incluidas:</Text>
              <div className={classes.text}>
                {liquidationSummaryInfo.promotions?.map((item) => {
                  return (
                    <Text
                      variant="H3-Medium"
                      color={PRIMARY_PAYMENT_DEFAULT}
                      key={`${item.title}-${item.promotion_id}`}>
                      {item.title}: {IntlNumberFormat(item.total_amount)}
                    </Text>
                  );
                })}
              </div>
              <GenericActionButton
                label="Descargar transacciones"
                onClick={() => mutate()}
                className={classes.button}
              />
            </>
          )}
          <CustomSnackBar
            showSnackbar={showToast}
            duration={5000}
            severity={snackBarSeverity}
            title={
              snackBarSeverity === SUCCESS_SEVERITY
                ? 'Se descargó el archivo con éxito'
                : 'Ocurrió un error. Por favor, volvé a intentar.'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default NewDebitInfo;
